import { useMemoize } from '@vueuse/core'
import { reqRightsDisplay } from '~/api'

export const useRightsDisplay = useMemoize(async () => {
  const { data } = await useAsyncData(() => reqRightsDisplay({ faq: false }))
  return data.value?.data
})

export const useRightDetail = async () => {
  const userInfo = useUserInfo()
  const rightsDisplay = await useRightsDisplay()
  return computed(() => {
    if (!userInfo.value || !rightsDisplay) {
      return null
    }
    const right = rightsDisplay.rights.find(
      (x) => x.rights_type === userInfo.value?.rights_type
    )
    const detail = right?.rights_by_time.find(
      (x) => x.id === userInfo.value?.rights_id
    )
    return detail
  })
}
